module.exports = __webpack_public_path__ + "img/player-empty.289d43b1.svg";